module.exports = __webpack_public_path__ + "img/img27.5b2bfa58.jpg";